import { render, staticRenderFns } from "./owner-answer-layer.vue?vue&type=template&id=094460e6&"
import script from "./owner-answer-layer.vue?vue&type=script&lang=js&"
export * from "./owner-answer-layer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports